export default __webpack_public_path__ + "static/media/scan-promo.c994585a.svg";